import React from "react";
import { useNavigate } from 'react-router-dom';
import './Main.css';

const storySections = [
  "It was a good morning! Ben the Turtle was excited to go to school.",
  "He brushed his teeth, ate a healthy breakfast, packed his backpack and swam to school.",
  "'Hello children' - said a teacher. 'Today we will be exploring the ocean bottom and collecting seashells'",
  "The class was eager to learn about the different types of seashells. They all swam to the coral reef to explore.",
  "'Look what shell I found' - said Anna, showing everyone her shell.",
  "'That is a horn snail shell' - explained the teacher.",
  "'Look here, I found a bittersweet clam shell' - exclaimed Mark and licked it.",
  "Children started laughing. It was bittersweet indeed.",
  "'Look at this beautiful purple shell' - Ben pointed to the shell on a sand. It opened up and everyone saw a pearl inside.",
  "Ben and his friends collected a lot of beautiful seashells. All so different and each one is unique.",
  "At the end of the class, the teacher showed how to make a necklace out of the shells, and asked everyone to make their own for the next class.",
  "Ben had a great and unique idea in his mind for what he can do.",
  "Next week, the class met again, and everybody brought their homework.",
  "Classmates showed their necklaces to Ben.",
  "Teacher asked Ben to show his homework to everyone.",
  "He showed everyone the bracelet that he did instead of a necklace.",
  "Teacher and friends smiled and said: 'What a great bracelet, Ben'",
  "They encouraged Ben, because everyone should be able to do what they like.",
  "'Teacher' - Ben added, 'you already had the necklace, so I decided to make the bracelet for you', and he gave his bracelet as a gift to his teacher.",
  "It feels great to be kind, creative, and to give gifts to others."
];

const BenTheTurtleStory = () => {
  const navigate = useNavigate();
  return (
    <div className="subscreen-container" style={{ maxWidth: 600, margin: '0 auto', padding: '2rem 1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
        <button onClick={() => navigate('/children-book')} className="back-button">←</button>
        <h1 style={{ margin: 0 }}>Ben the Turtle and a Gift for His Teacher</h1>
      </div>
      <div style={{ fontSize: '1.2rem', lineHeight: 1.7, background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px #0001', padding: '2rem' }}>
        {storySections.map((section, idx) => (
          <React.Fragment key={idx}>
            <p style={{ marginBottom: '1.5rem' }}>{section}</p>
            {idx < storySections.length - 1 && <hr style={{ border: 'none', borderTop: '1px dashed #e0e0e0', margin: '1.5rem 0' }} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BenTheTurtleStory; 